/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorlunchnoteplaceholder4Inputs */

const en_menueditorlunchnoteplaceholder4 = /** @type {(inputs: Menueditorlunchnoteplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 11:30–14:00, soup of the day included`)
};

const de_menueditorlunchnoteplaceholder4 = /** @type {(inputs: Menueditorlunchnoteplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. 11:30–14:00, inkl. Tagessuppe`)
};

/**
* | output |
* | --- |
* | "e.g. 11:30–14:00, soup of the day included" |
*
* @param {Menueditorlunchnoteplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorlunchnoteplaceholder4 = /** @type {((inputs?: Menueditorlunchnoteplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorlunchnoteplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorlunchnoteplaceholder4(inputs)
	return de_menueditorlunchnoteplaceholder4(inputs)
});
export { menueditorlunchnoteplaceholder4 as "menuEditorLunchNotePlaceholder" }